export default __webpack_public_path__ + "static/media/logo-1.5b880ad8.png";